<div class="profile-page bg-secondary">
  <main class="pt-4">
    <div class="container wow fadeIn">
      <legend>Rejected</legend>
      <!--Grid row-->
      <div class="row">
        <div class="table-responsive">
          <b-table striped hover :items="items" :fields="fields">
            <template #cell(createdOn)="data">
              <span>{{data.item.createdOn | formateDate}}</span>
            </template>
          </b-table>
        </div>
      </div>
      <!--Grid row-->
    </div>
  </main>
  <!--Main layout-->
</div>